// utils/withBusy.ts
export async function withBusy<T>(
    store: { busy: boolean },
    task: () => Promise<T>,
): Promise<T> {
    store.busy = true;
    try {
        return await task();
    } finally {
        store.busy = false;
    }
}

export async function withUpdating<T>(
    store: { updating: boolean },
    task: () => Promise<T>,
): Promise<T> {
    store.updating = true;
    try {
        return await task();
    } finally {
        store.updating = false;
    }
}